import { FieldValues, UseFormWatch } from "react-hook-form";
import isNil from "lodash/isNil";

import { Comment, CommentStatus } from "types";

import { SubRouteFieldProps } from "../types";

export const haveActiveComment = (comments: Comment[]) => comments.some((comment) => comment.status === CommentStatus.ACTIVE);

export const fieldsHaveActiveComment = (fields: SubRouteFieldProps[], comments: Comment[]): boolean => {
  return fields.some(({ field }) => {
    return comments.some((comment) => comment.fieldName === field && comment.status === CommentStatus.ACTIVE);
  });
};

export const haveResolvedComment = (comments: Comment[]) => comments.some((comment) => comment.status === CommentStatus.RESOLVED);

export const fieldsHaveResolvedComment = (fields: SubRouteFieldProps[], comments: Comment[]): boolean => {
  return fields.some(({ field }) => {
    return comments.some((comment) => comment.fieldName === field && comment.status === CommentStatus.RESOLVED);
  });
};

export const isFieldGroupValid = ({
  fields,
  touchedFields,
  dirtyFields,
  watch,
}: {
  fields: SubRouteFieldProps[];
  touchedFields: Record<string, boolean>;
  dirtyFields: Record<string, boolean>;
  watch: UseFormWatch<FieldValues>;
}): boolean => {
  return (
    (fields.every(({ field }) => touchedFields[field]) && fields.every(({ field }) => dirtyFields[field])) ||
    fields.filter(({ required }) => required).every(({ field }) => !isNil(watch(field)))
  );
};
